import { IAvailableStore, IStore } from '../types';

export const formatStores = (stores: IStore[]): IAvailableStore[] =>
    stores.map((store) => ({
        id: store.u_smd_sapnr,
        lat: parseFloat(store.u_smd_lat),
        lng: parseFloat(store.u_smd_lon),
        address: `${store.u_smd_address} ${store.u_smd_addressnumber}`,
        addressFr: `${store.u_smd_address_fr_be} ${store.u_smd_addressnumber}`,
        postalCode: store.u_smd_postalcode,
        city: store.u_smd_city,
        cityFr: store.u_smd_city_fr_be,
        storeAppointmentUrl: store.u_smd_urlstoreappointment,
        storeAppointmentUrlFr: store.u_smd_urlstoreappointment_fr_be,
        storeUrl: store.u_smd_urlstore,
        storeUrlFr: store.u_smd_urlstore_fr_be,
        storeName: store.u_smd_storename.split('-')[0],
        storeNameFr: store.u_smd_public_store_name_fr_be,
        storeNote: store.u_smd_storenote,
        storeNoteFr: store.u_smd_storenote_fr_be,
        specialHours: store.u_smd_gmbspecialhours,
        phone: store.u_smd_phone,
        openingHours: [
            // Align array index with day of the week according to the javascritp Date object
            // 0 = sunday, 1 = monday etc.
            {
                dayName: 'Zondag',
                dayNameFr: 'Dimanche',
                hours: store.u_smd_sal_sunday,
            },
            {
                dayName: 'Maandag',
                dayNameFr: 'Lundi',
                hours: store.u_smd_sal_monday,
            },
            {
                dayName: 'Dinsdag',
                dayNameFr: 'Mardi',
                hours: store.u_smd_sal_tuesday,
            },
            {
                dayName: 'Woensdag',
                dayNameFr: 'Mercredi',
                hours: store.u_smd_sal_wednesday,
            },
            {
                dayName: 'Donderdag',
                dayNameFr: 'Jeudi',
                hours: store.u_smd_sal_thursday,
            },
            {
                dayName: 'Vrijdag',
                dayNameFr: 'Vendredi',
                hours: store.u_smd_sal_friday,
            },
            {
                dayName: 'Zaterdag',
                dayNameFr: 'Samedi',
                hours: store.u_smd_sal_saturday,
            },
        ],
    }));
